import { getClient } from '@/lib/restClient';
import { MenuManagementBrandOptionGroupService } from '@/services/BrandOptionGroup/MenuManagementOptionGroupService';

export const useMenuManagementDeleteBrandOptionGroup = async (
  id: string
): Promise<void> => {
  const menuManagementBrandOptionGroupService =
    new MenuManagementBrandOptionGroupService(getClient());

  return menuManagementBrandOptionGroupService.delete(id);
};
